module.exports = __webpack_public_path__ + "img/violet_121.f89e829a.png";